<forge-card>
    <div class="dual-list" fxLayout="row" fxLayoutAlign>
        <div fxLayout="column" fxLayoutAlign style="width: 100%; height: 100%; flex: 1 1 auto">
            <forge-text-field style="margin: 1rem 1rem 0;" [ngClass]="{'dense-input': compact}" [density]="density"
                show-clear (forge-text-field-clear)="clearOptionSearch()">
                <input type="text" id="searchFilter-{{Name}}" [name]="Name" telemetry="Search-Tree"
                    [(ngModel)]="optionSearch" (change)="onChange()" [disabled]="isViewOnly" autocomplete="off">
                <label for="searchFilter-{{Name}}">Search options</label>
            </forge-text-field>
            <forge-card class="multiselect-list-card--first no-padding" id="{{dualListSelectId}}">
                <forge-scaffold>
                    <div slot="body" class="list-body"
                        [ngStyle]="{'height': compact ? 'calc(100vh - 329px)' : 'calc(100vh - 345px)'}">
                        <forge-list [dense]="compact ? '' : undefined">
                            @for (item of selectList; track item) {
                            <forge-list-item [value]="item.Key" (change)="selectItem(item.Key)">
                                <forge-checkbox slot="start" style="--forge-list-item-leading-margin-right: 0;"
                                    [disabled]="isViewOnly">
                                    <span class="forge-typography--body2"
                                        style="color: var(--forge-theme-text-high);">{{item.Value}}</span>
                                </forge-checkbox>
                            </forge-list-item>
                            }
                        </forge-list>
                    </div>
                </forge-scaffold>
            </forge-card>
        </div>
        <div fxLayout="column" fxLayoutAlign="center center" style="width: fit-content;">
            <forge-icon-button aria-label="Select all" (click)="selectAll()" [disabled]="isViewOnly">
                <forge-tooltip placement="bottom">Select all</forge-tooltip>
                <forge-icon name="chevron_double_right"></forge-icon>
            </forge-icon-button>

            <forge-icon-button (click)="addSelections()" aria-label="Select marked" [disabled]="isViewOnly">
                <forge-tooltip placement="bottom">Select marked</forge-tooltip>
                <forge-icon name="chevron_right"></forge-icon>
            </forge-icon-button>

            <forge-icon-button aria-label="Deselect marked" (click)="removeSelections()" [disabled]="isViewOnly">
                <forge-tooltip placement="bottom">Deselect marked</forge-tooltip>
                <forge-icon name="chevron_left"></forge-icon>
            </forge-icon-button>

            <forge-icon-button aria-label="Deselect all" (click)="deselectAll()" [disabled]="isViewOnly">
                <forge-tooltip placement="bottom">Deselect all</forge-tooltip>
                <forge-icon name="chevron_double_left"></forge-icon>
            </forge-icon-button>
        </div>
        <div fxLayout="column" fxLayoutAlign style="width: 100%;">
            <div fxLayout="row" class="forge-typography--label1 multiselect-list-card--label">
                <span>Selected options</span>
                <span fxFlex="auto"></span>
                <forge-icon-button aria-label="Sort Ascending" (click)="sort()" density="small">
                    <forge-tooltip placement="bottom">Sort Ascending</forge-tooltip>
                    <forge-icon name="sort_ascending"></forge-icon>
                </forge-icon-button>

                <forge-icon-button aria-label="Sort Descending" (click)="sort(true)" density="small">
                    <forge-tooltip placement="bottom">Sort Descending</forge-tooltip>
                    <forge-icon name="sort_descending"></forge-icon>
                </forge-icon-button>
            </div>
            <forge-card class="multiselect-list-card--second no-padding">
                <forge-scaffold>
                    <div slot="body" style="height: calc(100vh - 309px);">
                        <forge-list [dense]="compact ? '' : undefined">
                            @for (item of deselectList; track item) {
                            <forge-list-item [value]="item.Key" (change)="deselectItem(item.Key)">
                                <forge-checkbox slot="start" style="margin-right: 0;" [disabled]="isViewOnly">
                                    <span class="forge-typography--body2"
                                        style="color: var(--forge-theme-text-high);">{{item.Value}}</span>
                                </forge-checkbox>
                            </forge-list-item>
                            }
                        </forge-list>
                    </div>
                </forge-scaffold>
            </forge-card>
        </div>
        <div fxLayout="column" fxLayoutAlign="center start" style="padding-right:16px;">
            <div fxLayout="column">

                <forge-icon-button aria-label="Move selected item to top" (click)="moveToTop()"
                    [disabled]="moveUpDisabled">
                    <forge-icon name="chevron_double_up"></forge-icon>
                    <forge-tooltip placement="bottom">Move selected item to top</forge-tooltip>
                </forge-icon-button>
                <forge-icon-button aria-label="Move selected item up" (click)="moveUp()" [disabled]="moveUpDisabled">
                    <forge-icon name="chevron_up"></forge-icon>
                    <forge-tooltip placement="bottom">Move selected item up</forge-tooltip>
                </forge-icon-button>
                <forge-icon-button aria-label="Move selected item down" (click)="moveDown()"
                    [disabled]="moveDownDisabled">
                    <forge-icon name="chevron_down"></forge-icon>
                    <forge-tooltip placement="bottom">Move selected item down</forge-tooltip>
                </forge-icon-button>
                <forge-icon-button aria-label="Move selected item to bottom" (click)="moveToBottom()"
                    [disabled]="moveDownDisabled">
                    <forge-icon name="chevron_double_down"></forge-icon>
                    <forge-tooltip placement="bottom">Move selected item to bottom</forge-tooltip>
                </forge-icon-button>
            </div>
        </div>
    </div>
</forge-card>